import { useContext } from "react";
import FormContext from './Context'

const useForm =()=>{
    return useContext(FormContext)
}
export default useForm